import { render } from "./AssistantKindDialog.vue?vue&type=template&id=a1349946&scoped=true&ts=true"
import script from "./AssistantKindDialog.vue?vue&type=script&lang=ts"
export * from "./AssistantKindDialog.vue?vue&type=script&lang=ts"

import "./AssistantKindDialog.vue?vue&type=style&index=0&id=a1349946&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1349946"]])

export default __exports__